import script from "./checkboxComponentViewColumn.vue?vue&type=script&setup=true&lang=js"
export * from "./checkboxComponentViewColumn.vue?vue&type=script&setup=true&lang=js"

import "./checkboxComponentViewColumn.vue?vue&type=style&index=0&id=a8aeb65e&lang=css"

const __exports__ = script;

export default __exports__